'use client'
import React from 'react'
import PropTypes from 'prop-types'
import { HomeIcon, MatchesIcon, NewsIcon, SeriesIcon } from '@/shared/Icons'
import { allRoutes } from '@/shared/constants/allRoutes'
import CustomLink from '../customLink'
import { usePathname } from 'next/navigation'
import { getSlugUrl } from '@/shared/utils'
import dynamic from 'next/dynamic'

const AdZoneCatfish = dynamic(
  () => import('@/app/(locale)/cricket-hindi-news/AdZone-catfish'),
  { ssr: false }
)

const MobileMenu = () => {
  const asPath = usePathname()
  const isActive = (slug: string) => {
    return asPath === '/' + slug || (slug && asPath.startsWith(slug))
  }
  return (
    <div className='fixed bottom-0 left-0 w-full z-50 flex flex-col md:hidden '>
      <div className='w-full flex justify-center px-2'>
        <AdZoneCatfish />
      </div>

      <ul className='mobileMenu flex w-full text-center uppercase font-bold bg-headerFooter'>
        <li className='px-1 flex-grow min-w-[66px]'>
          <CustomLink
            className={`block text-xs h-full pt-2 pb-0.5 font-bold svg-nav ${
              isActive('') ? 'active' : ''
            }`}
            href='/'
          >
            <HomeIcon />
            Home
          </CustomLink>
        </li>
        <li className='px-1 flex-grow min-w-[66px]'>
          <CustomLink
            className={`block text-xs h-full pt-2 pb-0.5 font-bold svg-nav fill ${
              isActive('series') ? 'active' : ''
            }`}
            href={'/series'}
          >
            <SeriesIcon />
            Series
          </CustomLink>
        </li>
        <li className='px-1 flex-grow min-w-[66px]'>
          <CustomLink
            className={`block text-xs h-full pt-2 pb-0.5 font-bold svg-nav ${
              isActive(getSlugUrl('live-cricket-score')) ? 'active' : ''
            }`}
            href={allRoutes.liveScore}
          >
            <MatchesIcon />
            Matches
          </CustomLink>
        </li>
        <li className='px-1 flex-grow min-w-[66px]'>
          <CustomLink
            className={`block text-xs h-full pt-2 pb-0.5 font-bold svg-nav ${
              isActive('cricket-news') ? 'active' : ''
            }`}
            href={'/cricket-news'}
          >
            <NewsIcon />
            News
          </CustomLink>
        </li>
      </ul>
    </div>
  )
}

MobileMenu.propTypes = {
  handleMenuShow: PropTypes.func
}

export default MobileMenu
